import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon, Menu } from 'sugar-design';
import * as sdf from '@SDFoundation';

import Avatar from '../Avatar';
import Hoverdown from '../Hoverdown';
import SecretModal from '../SecretModal';

import { getI18n } from '@/utils/i18n';

import styles from './index.cm.styl';

const i18n = getI18n();
class UserTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSecretModal: false,
    };
    this.onSwitchLocale = this.onSwitchLocale.bind(this);
  }
  onSwitchLocale() {
    const { switchLocale } = this.props;
    return switchLocale(i18n.language === 'en-US' ? 'zh-CN' : 'en-US');
  }

  onShowSecretModal = () => this.setState({ showSecretModal: true });
  onHideSecretModal = () => this.setState({ showSecretModal: false });

  render() {
    const { currentUserEmail, onShowPasswordDialog } = this.props;
    const { showSecretModal } = this.state;
    return (
      <>
        <Hoverdown
          className="usertab"
          btnClassName="topbar__hoverdown-btn--user"
          menuClassName="topbar__hoverdown-menu user"
        >
          <Avatar className={styles.topbarAvatar} name={currentUserEmail} role="headhunter" />
          <ul className="topbar__hoverdown-list">
            <Menu.Item className={classNames(styles.topbarItem, styles.userInfo)}>
              <div className={styles.topUserInfo}>
                <div>
                  <Avatar
                    className={styles.hoverdownAvatar}
                    name={currentUserEmail}
                    role="headhunter"
                  />
                </div>
                <div>
                  <div className={classNames(sdf.fontWeightMedium, styles.userEmail)}>
                    {currentUserEmail}
                  </div>
                  <div className={styles.userRole}>{i18n.t`猎头`}</div>
                </div>
              </div>
            </Menu.Item>

            <Menu.Item className={styles.topbarItem} onClick={onShowPasswordDialog}>
              <div className={styles.topbarItemContentLeft}>
                <Icon name="lock" />
              </div>
              <div className={styles.topbarItemContent}>{i18n.t`修改密码`}</div>
            </Menu.Item>
            <Menu.Item className={styles.topbarItem} onClick={this.onSwitchLocale}>
              <div className={styles.topbarItemContentLeft}>
                <Icon name="website" />
              </div>
              <div
                className={styles.topbarItemContent}
              >{i18n.t`msg.NAV_COLUMN_LABEL_SWITCH_LANG`}</div>
              <div className={styles.topbarItemContentRight}>
                <Icon name="right" />
              </div>
            </Menu.Item>
            <Menu.Item className={styles.topbarItem} onClick={this.onShowSecretModal}>
              <div className={styles.topbarItemContentLeft}>
                <Icon name="project" />
              </div>
              <div className={styles.topbarItemContent}>{i18n.t`隐私政策`}</div>
            </Menu.Item>
            <Menu.Item className={classNames(styles.topbarItem, styles.hoverdownLogout)}>
              <form action="/api/headhunters/logout" method="post">
                <button type="submit" className={styles.hoverdownButton}>
                  <div className={styles.topbarItemContentLeft}>
                    <Icon name="logOff" />
                  </div>
                  <div className={styles.topbarItemContent}>{i18n.t`退出`}</div>
                </button>
              </form>
            </Menu.Item>
          </ul>
        </Hoverdown>
        {showSecretModal && <SecretModal onClose={this.onHideSecretModal} previewMode />}
      </>
    );
  }
}

UserTab.propTypes = {
  currentUserEmail: PropTypes.string,
  onShowPasswordDialog: PropTypes.func,
  switchLocale: PropTypes.func,
};

export default UserTab;
